var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B3B6D",
    d: "M0 0h128v128H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B42F34",
    d: "M128 0v128H0L128 0z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Arial",
    fontSize: 64
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 85
  }, "EN")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b16ee53c4fbd347fa4e6c665c1a9a6f3.svg";
export { ForwardRef as ReactComponent };